import React from 'react';
import {
  Button, ButtonColor, ButtonVariant, ICON_MINUS, ICON_PLUS, Typography,
} from '@doveit/bricks';
import * as styles from './CardStackItem.style';
import CardStackContext from '../../CardStackContext';

export interface CardStackItemProps extends React.AriaAttributes {
  title: React.ReactNode,
  description: React.ReactNode,
  children: React.ReactNode,
  subtitle?: React.ReactNode,
  position?: number,
}

const CardStackItem: React.FC<CardStackItemProps> = ({
  title,
  description,
  children,
  subtitle,
  position,
  'aria-label': ariaLabel = 'Singolo contenuto',
  ...rest
}) => {
  const {
    openPosition,
    updateOpenPosition,
  } = React.useContext(CardStackContext);

  const isOpen = React.useMemo(
    () => openPosition === position,
    [openPosition, position],
  );

  return (
    <article
      css={styles.base}
      $active={isOpen}
      aria-label={ariaLabel}
      {...rest}
    >
      <header css={styles.header}>
        <Typography.H3
          tagName="div"
          color="brand.primary"
        >
          {title}
        </Typography.H3>
        {subtitle && (
          <Typography.BODY>
            {subtitle}
          </Typography.BODY>
        )}
      </header>
      <div>
        {description}
      </div>
      {isOpen && (
        <div css={styles.content}>
          {children}
        </div>
      )}
      <div>
        <Button
          icon={isOpen ? ICON_MINUS : ICON_PLUS}
          aria-label={isOpen ? 'Pulsante per nascondere il contenuto' : 'Pulsante per visualizzare il contenuto'}
          label={isOpen ? 'Chiudi' : 'Leggi di più'}
          onClick={isOpen ? updateOpenPosition(undefined) : updateOpenPosition(position)}
          variant={ButtonVariant.LIGHT}
          color={ButtonColor.DARK}
          autoWidth
          withoutSpacing
        />
      </div>
    </article>
  );
};

export default CardStackItem;
